import React from 'react';

function Logs() {
    return <h2>Logs</h2>;
}

export default Logs;
